export default __webpack_public_path__ + "static/media/edit.f15f0952.svg";